var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selector-container" },
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-checkbox",
            {
              attrs: { name: "filterByOnlyMine" },
              model: {
                value: _vm.filterByOnlyMine,
                callback: function ($$v) {
                  _vm.filterByOnlyMine = $$v
                },
                expression: "filterByOnlyMine",
              },
            },
            [_vm._v("\n            Mes savoir-faire uniquement\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("vs-row", { staticClass: "mt-5" }, [
        _c("span", { staticClass: "vs-col" }, [
          _vm._v(
            "\n            Glissez-déposez les Savoir-faire que vous souhaitez ajouter :\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mt-5" },
        [
          _c("vs-col", { attrs: { "vs-w": "5.5" } }, [
            _c("h5", { staticClass: "text-primary font-bold" }, [
              _vm._v("Savoir-faire disponibles : "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("div", { staticClass: "font-bold" }, [
                  _vm._v("Choisir une filière de savoir-faire"),
                ]),
                _vm._v(" "),
                _c("Multiselect", {
                  attrs: {
                    id: "select-sector",
                    name: "sector",
                    options: _vm.sectors.data,
                    "track-by": "id",
                    label: "title",
                    multiple: false,
                    "group-select": false,
                    placeholder: "Choisir...",
                    "select-label": "",
                    "select-group-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    "deselect-group-label": "",
                    loading: _vm.sectors.loading,
                  },
                  model: {
                    value: _vm.sector,
                    callback: function ($$v) {
                      _vm.sector = $$v
                    },
                    expression: "sector",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("div", { staticClass: "font-bold" }, [
                  _vm._v("Choisir un métier centralisé"),
                ]),
                _vm._v(" "),
                _c("Multiselect", {
                  attrs: {
                    id: "select-occupation",
                    name: "occupation",
                    options: _vm.occupations.data,
                    "track-by": "id",
                    label: "title",
                    multiple: false,
                    "group-select": false,
                    placeholder: "Choisir...",
                    "select-label": "",
                    "select-group-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    "deselect-group-label": "",
                    loading: _vm.occupations.loading,
                    disabled: _vm.filterByOnlyMine,
                  },
                  model: {
                    value: _vm.occupation,
                    callback: function ($$v) {
                      _vm.occupation = $$v
                    },
                    expression: "occupation",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                !_vm.sector &&
                !_vm.occupation &&
                !_vm.filterByOnlyMine &&
                !Object.keys(_vm.occupationSkillsBySector).length
                  ? [
                      _c(
                        "vs-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { color: "rgb(231, 154, 23)", active: "true" },
                        },
                        [
                          _vm._v(
                            "\n                        Veuillez sélectionner une filière pour afficher les savoir-faire disponibles.\n                    "
                          ),
                        ]
                      ),
                    ]
                  : (_vm.sector ||
                      _vm.filterByOnlyMine ||
                      _vm.occupation ||
                      _vm.search) &&
                    !_vm.hasOccupationSkills
                  ? [
                      _c(
                        "vs-row",
                        { staticClass: "mt-6 mb-4" },
                        [
                          _c(
                            "vs-col",
                            { attrs: { "vs-w": "12" } },
                            [
                              _c("vs-input", {
                                staticClass: "w-full",
                                attrs: {
                                  label: "Recherche",
                                  name: "JobFilterOccupationSkills",
                                  placeholder: "Rechercher des savoir-faire...",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { color: "rgb(21, 16, 255)", active: "true" },
                        },
                        [
                          _vm._v(
                            "\n                        Aucun savoir-faire correspondant aux critères.\n                    "
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "vs-row",
                        { staticClass: "mt-6 mb-4" },
                        [
                          _c(
                            "vs-col",
                            { attrs: { "vs-w": "12" } },
                            [
                              _c("vs-input", {
                                staticClass: "w-full",
                                attrs: {
                                  label: "Recherche",
                                  name: "JobFilterOccupationSkills",
                                  placeholder: "Rechercher des savoir-faire...",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-list",
                        {
                          staticStyle: {
                            height: "250px",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "InfiniteScrollContainer",
                            {
                              attrs: {
                                threshold: 50,
                                onLoadMore: _vm.handleScrollLoadMore,
                              },
                            },
                            [
                              _vm._l(
                                _vm.occupationSkillsBySector,
                                function (listItem, i) {
                                  return [
                                    _c("vs-list-header", {
                                      attrs: { color: "primary", title: i },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "draggable",
                                      {
                                        staticClass: "p-2 cursor-move",
                                        attrs: {
                                          value: listItem,
                                          group: "skills",
                                        },
                                      },
                                      _vm._l(listItem, function (item, j) {
                                        return _c("vs-list-item", {
                                          key: i + "-" + j,
                                          attrs: {
                                            title: `${item.title}${
                                              item.establishment
                                                ? " - " +
                                                  item.establishment.name
                                                : ""
                                            }`,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          [
            _c(
              "vs-col",
              {
                attrs: {
                  "vs-type": "flex",
                  "vs-justify": "center",
                  "vs-align": "center",
                  "vs-w": "1",
                },
              },
              [
                _c("chevrons-right-icon", {
                  staticClass: "custom-class",
                  attrs: { size: "3x", stroke: "rgb(var(--vs-primary))" },
                }),
              ],
              1
            ),
          ],
          _vm._v(" "),
          _c(
            "vs-col",
            { attrs: { "vs-w": "5.5" } },
            [
              _c("h5", { staticClass: "text-primary font-bold" }, [
                _vm._v("Savoir-faire choisis : "),
              ]),
              _vm._v(" "),
              _c(
                "vs-list",
                { staticClass: "scrollable_list" },
                [
                  _c(
                    "draggable",
                    {
                      staticClass: "p-2 cursor-move scrollable_list",
                      attrs: {
                        group: "skills",
                        emptyInsertThreshold: 250,
                        direction: "horizontal",
                      },
                      on: { input: _vm.onSelectedChange },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    },
                    _vm._l(_vm.selected, function (listItem, i) {
                      return _c("vs-list-item", {
                        key: listItem.id + "-" + i,
                        attrs: {
                          id: "occupationSkillSelected_" + listItem.id,
                          title:
                            listItem.title +
                            (listItem.establishment
                              ? " - " + listItem.establishment.name
                              : ""),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }